<template>
  <div class="download-win">
    <video autoplay loop muted>
      <source src="https://img.loklok.video/fe/1c538669-f670-413a-827d-aef92e25ed78/landscape.mp4" />
    </video>
    <div class="info">
      <img src="https://img.loklok.video/img/202409251725718.png?imageMogr2/format/webp" alt="" />
      <div class="right">
        <h4>LOKLOK</h4>
        <h5>The computer version of loklok is now online</h5>
        <p>Featuring a large collection of popular movies and TV series. Come and watch.</p>
        <img src="" alt="" />
        <!-- 桶ironman-dev -->
        <a :href="url.officialPCClient" target="_blank" :data-bury-params="JSON.stringify({ UM_Key_ButtonName: '下载windows' })">
          <img class="download-btn" src="https://img.loklok.video/img/20241126-174425.1.jpeg?imageMogr2/format/webp" alt="" />
        </a>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  async asyncData({ app, redirect, $ua }) {
    try {
      let res = await app.$api.fetchDownloadLink()
      console.log('res:', res)
      return {
        url: res
      }
    } catch (error) {
      console.log('detail error:', error)
    }
  }
}
</script>
<style lang="scss" scoped>
.download-win {
  height: calc(100vh - 60px);
}
video {
  position: fixed;
  inset: 0;
  min-width: 100%;
  min-height: 100%;
  z-index: -1;

  source {
    min-width: 100%;
    min-height: 100%;
    /* width: 100%;
          height: 100%; */
  }
}

.info {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;

  > img {
    width: 716px;
    height: 408px;
  }

  .right {
    margin-inline-start: 44px;
    padding-inline-end: 100px;

    h4 {
      color: var(--f-5-f-5-f-5, #f5f5f5);
      font-family: Roboto;
      font-size: 32px;
      font-style: normal;
      font-weight: 900;
      line-height: 150%;
      /* 48px */
      text-transform: uppercase;
      margin-bottom: 24px;
    }
    h5 {
      color: var(--f-5-f-5-f-5, #f5f5f5);
      font-family: Roboto;
      font-size: 26px;
      font-style: normal;
      font-weight: 500;
      line-height: 120%; /* 31.2px */
      margin-bottom: 12px;
    }
    p {
      color: var(--f-5-f-5-f-5, #f5f5f5);
      font-family: Roboto;
      font-size: 18px;
      font-style: normal;
      font-weight: 500;
      line-height: 120%; /* 21.6px */
    }

    .download-btn {
      margin-top: 12px;
      width: 128px;
      height: 36.948px;
    }
  }
}
</style>
